import { MutationTree } from 'vuex';
import { ConsumerApplicationState, ConsumerApplication, ConsumerApplicationStatus, Identity, Address,
     ContactInformation, IdentityVerification, EmploymentAndIncome, AdditionalCardholder, Device, Candidate, ConsumerApplicationResponse, AccountConversion } from './types';
import {
    SET_IDENTITY_FIELDS,
    SET_IDENTITY_ERRORS,
    SET_ADDRESS_FIELDS,
    SET_ADDRESS_ERRORS,
    SET_CONTACT_INFORMATION_FIELDS,
    SET_CONTACT_INFORMATION_ERRORS,
    SET_IDENTITY_VERIFICATION_FIELDS,
    SET_IDENTITY_VERIFICATION_ERRORS,
    SET_EMPLOYMENT_AND_INCOME_FIELDS,
    SET_EMPLOYMENT_AND_INCOME_ERRORS,
    SET_ADDITIONAL_CARDHOLDER_FIELDS,
    SET_ADDITIONAL_CARDHOLDER_ERRORS,
    SET_CONSUMER_RESPONSE,
    SET_CONSUMER_APPLICATION_VALID,
    SET_CONSUMER_APPLICATION_STATUS,
    SET_CONSUMER_APPLICATION_DEVICE_ID,
    SET_CONSUMER_APPLICATION_FI_ID,
    SET_CONSUMER_APPLICATION_RESERVATION_CODE,
    SET_ACCOUNT_CONVERSION_STATUS,
    SET_CONSUMER_RESPONSE_ERRORS,
} from '../mutation-types';

export const mutations: MutationTree<ConsumerApplicationState> = {

    [SET_IDENTITY_FIELDS](state, payload: Identity) {
        state.error = false;
        if(state.consumerApplication) {
            state.consumerApplication.identity = payload;
        } else {
            const consumerApplication: ConsumerApplication =  {
                contactInformation: payload
            } as ConsumerApplication;
            state.consumerApplication = consumerApplication;
        }
    },
    [SET_IDENTITY_ERRORS](state) {
        state.error = true;
    },

    [SET_ADDRESS_FIELDS](state, payload: Address) {
        state.error = false;
        if(state.consumerApplication) {
            state.consumerApplication.address = payload;
        } else {
            const consumerApplication: ConsumerApplication =  {
                contactInformation: payload
            } as ConsumerApplication;
            state.consumerApplication = consumerApplication;
        }
    },
    [SET_ADDRESS_ERRORS](state) {
        state.error = true;
    },

    [SET_CONTACT_INFORMATION_FIELDS](state, payload: ContactInformation) {
        state.error = false;
        if(state.consumerApplication) {
            state.consumerApplication.contactInformation = payload;
        } else {
            const consumerApplication: ConsumerApplication =  {
                contactInformation: payload
            } as ConsumerApplication;
            state.consumerApplication = consumerApplication;
        }
    },
    [SET_CONTACT_INFORMATION_ERRORS](state) {
        state.error = true;
    },

    [SET_IDENTITY_VERIFICATION_FIELDS](state, payload: IdentityVerification) {
        state.error = false;
        if(state.consumerApplication) {
            state.consumerApplication.identityVerification = payload;
        } else {
            const consumerApplication: ConsumerApplication =  {
                contactInformation: payload
            } as ConsumerApplication;
            state.consumerApplication = consumerApplication;
        }
    },
    [SET_IDENTITY_VERIFICATION_ERRORS](state) {
        state.error = true;
    },

    [SET_EMPLOYMENT_AND_INCOME_FIELDS](state, payload: EmploymentAndIncome) {
        state.error = false;
        if(state.consumerApplication) {
            state.consumerApplication.employmentAndIncome = payload;
        } else {
            const consumerApplication: ConsumerApplication =  {
                contactInformation: payload
            } as ConsumerApplication;
            state.consumerApplication = consumerApplication;
        }    },
    [SET_EMPLOYMENT_AND_INCOME_ERRORS](state) {
        state.error = true;
    },
    [SET_CONSUMER_APPLICATION_DEVICE_ID](state, deviceId: string) {
        state.error = false;
        const device: Device = {
        };
        device['device_id'] = deviceId;
        if(state.consumerApplication) {

            state.consumerApplication.device =  device;
        } else {
            const consumerApplication: ConsumerApplication =  {
                device: device
            } as ConsumerApplication;
            state.consumerApplication = consumerApplication;
        }    
    },
    [SET_CONSUMER_APPLICATION_FI_ID](state, fiId: number) {
        state.error = false;
        if(state.consumerApplication) {
            state.consumerApplication.fiId = fiId;
        } else {
            const consumerApplication: ConsumerApplication =  {
                fiId: fiId
            } as ConsumerApplication;
            state.consumerApplication = consumerApplication;
        }             
    },
    [SET_CONSUMER_APPLICATION_RESERVATION_CODE](state, reservationCode: string) {
        state.error = false;
        const candidate: Candidate = {
            reservationCode: reservationCode
        }
        if(state.consumerApplication) {
            state.consumerApplication.candidate = candidate;
        } else {
            const consumerApplication: ConsumerApplication =  {
                candidate: candidate
            } as ConsumerApplication;
            state.consumerApplication = consumerApplication;
        }         
    },
    [SET_ADDITIONAL_CARDHOLDER_FIELDS](state, payload: AdditionalCardholder) {
        state.error = false;
        if(state.consumerApplication) {
            state.consumerApplication.additionalCardholder = payload;
        } else {
            const consumerApplication: ConsumerApplication =  {
                contactInformation: payload
            } as ConsumerApplication;
            state.consumerApplication = consumerApplication;
        }    },
    [SET_ADDITIONAL_CARDHOLDER_ERRORS](state) {
        state.error = true;
    },

    [SET_CONSUMER_RESPONSE](state, consumerApplicationResponse: ConsumerApplicationResponse) {
        consumerApplicationResponse!.pricing!.creditLine = Number(consumerApplicationResponse!.pricing!.creditLine).toLocaleString()
        state.consumerApplicationResponse = consumerApplicationResponse;
    },

    [SET_CONSUMER_APPLICATION_VALID](state, isValid: boolean) {
        state.isValidApplicationForm = isValid;
    },

    [SET_CONSUMER_APPLICATION_STATUS](state, status: ConsumerApplicationStatus) {
        state.processingStatus = status;
    },

    [SET_ACCOUNT_CONVERSION_STATUS](state, consent: boolean) {
        state.error = false;
        if(state.consumerApplication != undefined){
            const conversion: AccountConversion = {};
            state.consumerApplication.accountConversion = conversion;
            state.consumerApplication.accountConversion.consent = consent;
        }

    },

    [SET_CONSUMER_RESPONSE_ERRORS](state, error: boolean) {
        state.error = error;
    },
};
